import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelForm: {},
    statusPro: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    statusPro(state) {
      return state.statusPro;
    },
    modelForm(state) {
      return state.modelForm;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertModelForm(state, modelForm) {
      state.modelForm = modelForm;
    },
    passSuccess(state, codeVerifMatch) {
      state.statusPro = codeVerifMatch;
    },
    passError(state) {
      state.statusPro = 'error';
    },
    sendCodeSuccess(state, codeVerifGen) {
      state.statusPro = codeVerifGen;
    },
    sendCodeError(state) {
      state.statusPro = 'error';
    },
    delSuccess(state, codeVerifMatch) {
      state.statusPro = codeVerifMatch;
    },
    delError(state) {
      state.statusPro = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proAccountSchema();
        const schema = res.data;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadModelForm({ commit }, payload) {
      try {
        const id = getInstProfesId();

        let model = {};
        if (payload === undefined) {
          model.usersPin = false;
        } else {
          const usersPin = payload.usersPin;
          model.usersPin = usersPin;
        }

        const res = await apiClient.profesAccount(id, model);
        const modelForm = res.data.data;
        commit('insertModelForm', modelForm);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async passAccount({ commit }, payload) {
      try {
        const id = getInstProfesId();

        let model = {};
        if (payload === undefined) {
          model.usersCodeVerif = false;
        } else {
          model = payload.model;
          model.type = 'Pro';
        }

        const res = await apiClient.usersPass(id, model);
        const codeVerifMatch = res.data.data.codeVerifMatch;
        commit('passSuccess', codeVerifMatch);
      } catch (e) {
        console.error('Error cuenta');
        commit('passError');
        throw e;
      }
    },
    async reSendCode({ commit }, payload) {
      try {
        const id = getInstProfesId();

        let model = {};
        if (payload === undefined) {
          model.usersCodeVerif = false;
        } else {
          model = payload.model;
          model.type = 'Pro';
        }
        model.id = id;

        const res = await apiClient.usersCodeVerifGen(model);
        const codeVerifGen = res.data.data.codeVerifGen;
        commit('sendCodeSuccess', codeVerifGen);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error reenviando');
        commit('sendCodeError');
        throw error;
      }
    },
    async delAccount({ commit }, payload) {
      try {
        const id = getInstProfesId();

        let model = {};
        if (payload === undefined) {
          model.usersCodeVerif = false;
        } else {
          model = payload.model;
          model.type = 'Pro';
        }

        const res = await apiClient.usersDelAccount(id, model);
        const codeVerifMatch = res.data.data.codeVerifMatch;
        commit('delSuccess', codeVerifMatch);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error borrando');
        commit('delError');
        throw error;
      }
    },
  },
};
